import React from "react";
import moment from "moment-timezone";
import { Table, TableContainer, TableHead, TableRow, TableCell, TableBody, Grid, CircularProgress, Pagination, PaginationItem } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { CredentialResponse, UserActivity, UserActivityResponse } from "../../services/Types";
import { defaultLimit } from "../../services/Constatnts";
import { generateExecutedByValue } from "../../services/CommonHelpers";

const timeZone = moment.tz.guess();

const useStyles = makeStyles({
  contentHolder: {
  },
  loaderHolder: {
    position: "relative",
    minHeight: "100px"
  },
  circularProgressLoader: {
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)"
  }
});

const UserActivityTable = ({
  userCredentials,
  userActivity,
  handleUserActivityPageChange,
  activeUserActivityPage
}: {
  userCredentials: CredentialResponse,
  userActivity: UserActivityResponse,
  handleUserActivityPageChange: any,
  activeUserActivityPage: number
}) => {
  const classes = useStyles();

  const paginationCount = Math.ceil((userActivity.count/defaultLimit));

  return (
    <Grid container columnSpacing={8} rowSpacing={1} className={classes.contentHolder}>
      <Grid item xs={12}>
        <TableContainer>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Description</TableCell>
                <TableCell>Application</TableCell>
                <TableCell>Executed By</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              { 
                userActivity ?
                userActivity.items.map((activityItem: UserActivity, index: number) => {
                  const executedBy = generateExecutedByValue(activityItem, userCredentials);
                  
                  return (
                  <TableRow
                    key={index}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell >{moment(activityItem?.executedAt).tz(timeZone).format("L h:mm A z")}</TableCell>
                    <TableCell>{activityItem.type}</TableCell>
                    <TableCell>{activityItem.description}</TableCell>
                    <TableCell>{activityItem.application}</TableCell>
                    <TableCell>{executedBy}</TableCell>
                  </TableRow>
                )})
                :
                <TableRow>
                  <TableCell colSpan={4}>
                    <div  className={classes.loaderHolder}>
                      <CircularProgress className={classes.circularProgressLoader}/>
                    </div>
                  </TableCell>
                </TableRow>
              }
            </TableBody>
          </Table>
        </TableContainer>
        <Pagination 
          shape="rounded" 
          count={paginationCount} 
          defaultPage={activeUserActivityPage} 
          siblingCount={1} 
          boundaryCount={1}
          onChange={(_, value) => handleUserActivityPageChange(value)}
          renderItem={(item) => (
            <PaginationItem
              components={{ previous: () => (<span>Previous</span>), next: () => (<span>Next</span>) }}
              {...item}
            />
          )}
          />
      </Grid>
    </Grid>
  );
}

export default UserActivityTable;